"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.done = exports.postMessageToClient = exports.postMessageToProvider = exports.stringifyWindowFeatures = exports.defaultWindowFeatures = exports.createWindow = void 0;
/** A reference to the current nfid sdk window */
let sdkWindow;
let origin;
const INTERRUPTION_CHECK_INTERVAL = 1000;
/**
 * Open a new sdk window to facilitate some credential verification.
 * @param url url string (todo: fixed?)
 * @param windowFeatures browser window features as string or object
 * @see {@link WindowFeatures}
 * @return void
 */
function createWindow(url, reject, windowFeatures) {
    origin = new URL(url).origin;
    sdkWindow === null || sdkWindow === void 0 ? void 0 : sdkWindow.close();
    sdkWindow = window.open(url, 'nfidSdk', windowFeatures
        ? typeof windowFeatures === 'string'
            ? windowFeatures
            : stringifyWindowFeatures(Object.assign(Object.assign({}, exports.defaultWindowFeatures), windowFeatures))
        : stringifyWindowFeatures(exports.defaultWindowFeatures));
    function checkInteruption() {
        if (sdkWindow === null || sdkWindow === void 0 ? void 0 : sdkWindow.closed) {
            reject(new Error(`Terminated by user.`));
        }
        else {
            setTimeout(checkInteruption, INTERRUPTION_CHECK_INTERVAL);
        }
    }
    setTimeout(checkInteruption, INTERRUPTION_CHECK_INTERVAL);
}
exports.createWindow = createWindow;
/**
 * Default configuration for the sdk window.
 */
exports.defaultWindowFeatures = {
    height: 705,
    width: 525,
    top: window.screen.height / 2 - 705 / 2,
    left: window.screen.width / 2 - 525 / 2,
    toolbar: false,
    location: false,
    menubar: false,
};
/**
 * Transform window features object to string
 * @param options WindowFeatures
 * @see {@link WindowFeatures}
 * @returns string
 */
function stringifyWindowFeatures(options) {
    function paramToString(key, value) {
        return `${key}=${typeof value === 'boolean' ? (value ? 1 : 0) : value}`;
    }
    return Object.entries(options).reduce((agg, [k, v]) => `${agg}${paramToString(k, v)},`, '');
}
exports.stringifyWindowFeatures = stringifyWindowFeatures;
/**
 * Send a message to the provider window.
 * @param event {@link BaseEvent}
 */
function postMessageToProvider(event) {
    sdkWindow === null || sdkWindow === void 0 ? void 0 : sdkWindow.postMessage(event, origin);
}
exports.postMessageToProvider = postMessageToProvider;
/**
 * Send a message to the client window.
 * @param event {@link BaseEvent}
 */
function postMessageToClient(event) {
    window.opener.postMessage(event, '*');
}
exports.postMessageToClient = postMessageToClient;
/**
 * Close the provider window.
 */
function done() {
    sdkWindow === null || sdkWindow === void 0 ? void 0 : sdkWindow.close();
    sdkWindow = null;
}
exports.done = done;
